import Vue from 'vue'
import rest from '../../rest/config'

const GET_USERINFO_BY_EXID = 'GET_USERINFO_BY_EXID'
const GET_USERINFO_BY_MOBILE = 'GET_USERINFO_BY_MOBILE'
const GET_USER_CAR_LIST = 'GET_USER_CAR_LIST'

const UPDATE_USERINFO = 'UPDATE_USERINFO'
const UPDATE_USER_CAR_LIST = 'UPDATE_USER_CAR_LIST'
const UPDATE_USER_DEFAULT_CAR_ID = 'UPDATE_USER_DEFAULT_CAR_ID'

const state = {
  userInfo: {},
  carList: []
}

const mutations = {
  [UPDATE_USERINFO](state, userInfo) {
    state.userInfo = userInfo
  },
  [UPDATE_USER_CAR_LIST](state, carList) {
    state.carList = carList
  },
  [UPDATE_USER_DEFAULT_CAR_ID](state, defaultCarId) {
    state.userInfo.default_car_id = defaultCarId
  }
}

const actions = {
  // 通过 外部联系人Id 获取用户信息
  async [GET_USERINFO_BY_EXID]({ commit, dispatch }, externalId) {
    return getUserInfo({ commit, dispatch }, GET_USERINFO_BY_EXID, { external_userid: externalId, _from_agent: 'maintenance' })
  },
  // 通过手机号获取用户信息
  async [GET_USERINFO_BY_MOBILE]({ commit, dispatch }, phoneNumber) {
    return getUserInfo({ commit, dispatch }, GET_USERINFO_BY_MOBILE, { mobile_number: phoneNumber })
  },
  // 根据用户Id获取用户车辆信息
  async [GET_USER_CAR_LIST]({ commit, dispatch }, userId) {
    dispatch('UPDATE_LOADING', { status: true, text: '加载中...' }, { root: true })
    const { code, message, data } = await rest.aftersales.getCarList(userId)()
    dispatch('UPDATE_LOADING', { status: false }, { root: true })
    if (code !== 0) {
      Vue.$cvux.toast.show({ type: 'text', text: message })
      return
    }
    commit(UPDATE_USER_CAR_LIST, data || [])
    return data
  }
}

// 通过 external_userId 或 手机号码 获取用户信息
async function getUserInfo({ commit, dispatch }, type, params) {
  const handle = type === GET_USERINFO_BY_EXID ? rest.aftersales.getExternalUserInfo : rest.aftersales.getUserInfoByPhoneNumber
  dispatch('UPDATE_LOADING', { status: true, text: '加载中...' }, { root: true })
  const { code, message, data } = await handle(params)
  dispatch('UPDATE_LOADING', { status: false }, { root: true })
  if (code !== 0) {
    Vue.$cvux.toast.show({ type: 'text', text: message })
    return
  }
  commit(UPDATE_USERINFO, data || {})
  return data
}

export default {
  state,
  actions,
  mutations,
  namespaced: true
}
